module.exports = __webpack_public_path__ + "static/media/hebebühne_antwort1.28afa073.jpg";